import React from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart3, Users, Home } from 'lucide-react';
import clsx from 'clsx';

const Sidebar: React.FC = () => {
  const navItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: Home,
      exact: true
    },
    {
      name: 'Users',
      path: '/dashboard/users',
      icon: Users
    },
  ];

  return (
    <div className="w-64 bg-white dark:bg-dark-800 shadow-sm border-r border-gray-200 dark:border-dark-700 h-full">
      {/* Logo/Brand */}
      <div className="p-6 border-b border-gray-200 dark:border-dark-700">
        <div className="flex items-center space-x-3">
          <div className="h-10 w-10 bg-primary-600 rounded-lg flex items-center justify-center">
            <BarChart3 className="h-6 w-6 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              VMS Admin
            </h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Dashboard
            </p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.exact}
            className={({ isActive }) =>
              clsx(
                'flex items-center space-x-3 px-4 py-3 text-sm font-medium rounded-lg transition-colors',
                isActive
                  ? 'bg-primary-50 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300 border-l-4 border-primary-600'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-700 hover:text-gray-900 dark:hover:text-white'
              )
            }
          >
            <item.icon className="h-5 w-5" />
            <span>{item.name}</span>
          </NavLink>
        ))}
      </nav>
        
      {/* Footer */}
      {/* <div className="absolute bottom-4 left-4 right-4">
        <div className="bg-gray-50 dark:bg-dark-700 rounded-lg p-4">
          <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
            VMS Admin v1.0.0
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default Sidebar;